const columns = [

  {
    headerLabel: 'rotativeInventory.dtInventory',
    type: 'date',
    field: 'dtInventory',
    className: 'small-column align-left',
    render: true,
    fixed: false,
    order: true
  },
  {
    headerLabel: 'rotativeInventory.startHrInventory',
    type: 'general',
    field: 'startHrInventory',
    className: 'small-column align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.hrInventory',
    type: 'general',
    field: 'hrInventory',
    className: 'small-column align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.dsBranch',
    type: 'general',
    field: 'dsBranch',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.cdLm',
    type: 'general',
    field: 'cdLm',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.dsProduct',
    type: 'general',
    field: 'dsProduct',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.dsLot',
    type: 'general',
    field: 'dsLot',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.section',
    type: 'general',
    field: 'section',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'Tipo de lista',
    type: 'general',
    field: 'listType',
    className: 'align-center',
    render: true,
    fixed: false,
  },

  {
    headerLabel: 'stock.adjustment.done.label.variation',
    type: 'general',
    field: 'variations',
    className: 'align-center',
    render: true,
    fixed: false,
  },

  {
    headerLabel: 'rotativeInventory.c50v2',
    type: 'decimal',
    field: 'c50',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.c50Countedv2',
    type: 'decimal',
    field: 'c50Counted',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.qtDifferencev2',
    type: 'decimal',
    field: 'qtDifference',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.dpac',
    type: 'general',
    field: 'dpac',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.vlDifference',
    type: 'general',
    field: 'vlDifferenceValue',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.accurrancy',
    type: 'general',
    field: 'accurrancy',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.integrated',
    eyeIcon:true,
    type: 'general',
    field: 'integrated',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.dsJustification',
    type: 'general',
    field: 'dsJustification',
    className: 'align-center',
    render: true,
    fixed: false,
  },

  {
    headerLabel: 'position',
    type: 'general',
    field: 'dsPosition',
    className: 'align-left',
    render: true,
    fixed: false,
  },

  {
    headerLabel: 'rotativeInventory.ldap',
    type: 'general',
    field: 'ldap',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.warehouse',
    type: 'general',
    field: 'warehouse',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.provider',
    type: 'general',
    field: 'provider',
    className: 'align-center',
    render: true,
    fixed: false,
  },
]

export default columns
